import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { fadeAnimation } from '@erbfactors/shared-ui';
import { FormField } from '@erbfactors/util-forms';
import { isControlRequired } from '../../../helpers/is-control-required';

@Component({
  selector: 'erbfactors-select-control',
  templateUrl: './select-control.component.html',
  styleUrls: ['./select-control.component.scss'],
  animations: [fadeAnimation],
})
export class SelectControlComponent implements OnInit {
  @Input() errors: { name: string; message: string }[] = [];
  @Input() showErrors = true;
  @Input() field: FormField;
  @Input() control: AbstractControl;
  @Input() form: FormGroup;
  required: boolean;
  styles: Partial<CSSStyleDeclaration>;
  ngOnInit() {
    this.styles = {
      display: 'flex',
      flexDirection: 'column',
      ...this.field.styles,
    };
    this.required = isControlRequired(this.control);
    if (this.required) {
      this.errors.push({
        name: 'required',
        message: 'Το πεδίο είναι υποχρεωτικό.',
      });
    }
  }
}
